// extracted by mini-css-extract-plugin
export default {"userInfoOuter":"UserInfo_userInfoOuter__ZIGUE","userInfoInner":"UserInfo_userInfoInner__pkNP5","userInfoDateContainer":"UserInfo_userInfoDateContainer__BVo6M"};